export default "__VITE_ASSET__Dg3D0wvh__"